import { createApiSelectors } from 'reacticoon/selector'
import { formatUserMe } from './format'

export const fetchUserMeSelectors = createApiSelectors('App::UserMeModule', formatUserMe)
